<template>
  <form id="frmData" action="https://surepay.ndml.in/SurePayPayment/sp/processRequest" method="post">
    <div>
      <input type="hidden" id="checksum" name="checksum" v-model="checksum" />

      <input type="hidden" id="messageType" name="messageType" v-model="messageType" />
      <input type="hidden" id="merchantId" name="merchantId" v-model="merchantId" />
      <input type="hidden" id="serviceId" name="serviceId" v-model="serviceId" />
      <input type="hidden" id="orderId" name="orderId" v-model="orderId" />
      <input type="hidden" id="customerId" name="customerId" v-model="customerId" />
      <input type="hidden" id="transactionAmount" name="transactionAmount" v-model="transactionAmount" />
      <input type="hidden" id="currencyCode" name="currencyCode" v-model="currencyCode" />
      <input type="hidden" id="requestDateTime" name="requestDateTime" v-model="requestDateTime" />
      <input type="hidden" id="successUrl" name="successUrl" v-model="successUrl" />
      <input type="hidden" id="failUrl" name="failUrl" v-model="failUrl" />
      <input type="hidden" id="additionalField1" name="additionalField1" v-model="additionalField1" />
      <input type="hidden" id="additionalField2" name="additionalField2" v-model="additionalField2" />
      <input type="hidden" id="additionalField3" name="additionalField3" v-model="additionalField3" />
      <input type="hidden" id="additionalField4" name="additionalField4" v-model="additionalField4" />
      <input type="hidden" id="additionalField5" name="additionalField5" v-model="additionalField5" />
      <br />
      <div style="margin-top: 20px; text-align: center">
        <h3>Please do not close and refresh browser</h3>
      </div>
      <div style="color: red; margin-top: 20px; text-align: center">
        <h4>Redirect to payment getway website for payment</h4>
      </div>
      <div style="color: red; margin-top: 20px; text-align: center">
        <img src="../assets/images/payprocess.gif" />
      </div>
    </div>
  </form>
</template>
<script>
import axios from "axios";
import Router from "vue-router";
import config from "@/router/globalConfig";
import TransJS from "./servicesJS/Transaction.js";
export default {
  name: "TransRequest",
  data() {
    return {
      bookingID: -1,
      booking_list: [],
      //request for payment gatway server
      messageType: "",
      checksum: "",
      merchantId: "",
      serviceId: "",
      orderId: "",
      customerId: "",
      transactionAmount: "",
      currencyCode: "",
      requestDateTime: "",
      successUrl: "",
      failUrl: "",
      additionalField1: "",
      additionalField2: "",
      additionalField3: "",
      additionalField4: "",
      additionalField5: "",
      isTourOperatorPayment: false,
    };
  },
  methods: {
    getdata() {
      const _data_ = { bookingID: this.bookingID };
      TransJS.getTransRequest(_data_, this.isTourOperatorPayment).then(
        (response) => {
          // console.log(response);
          if (response.data.isSuccess) {
            // console.log(response.data.result);
            document.getElementById("messageType").value =
              response.data.result.messageType; //1
            document.getElementById("merchantId").value =
              response.data.result.merchantId; //2
            document.getElementById("serviceId").value =
              response.data.result.serviceId; //3
            document.getElementById("orderId").value =
              response.data.result.orderId; //4
            document.getElementById("customerId").value =
              response.data.result.bookingId; //5
            document.getElementById("transactionAmount").value =
              response.data.result.transactionAmount; //6
            document.getElementById("currencyCode").value =
              response.data.result.currencyCode; //7
            document.getElementById("requestDateTime").value =
              response.data.result.requestDateTime; //8
            document.getElementById("successUrl").value =
              response.data.result.successUrl; //9
            document.getElementById("failUrl").value =
              response.data.result.failUrl; //10
            document.getElementById("additionalField1").value =
              response.data.result.additionalField1; //11
            document.getElementById("additionalField2").value =
              response.data.result.additionalField2; //12
            document.getElementById("additionalField3").value =
              response.data.result.additionalField3; //13
            document.getElementById("additionalField4").value =
              response.data.result.additionalField4; //14
            document.getElementById("additionalField5").value =
              response.data.result.additionalField5; //15
            document.getElementById("checksum").value =
              response.data.result.checksum; //16

            document.getElementById("frmData").action =
              response.data.result.requestURL; //17
            document.getElementById("frmData").submit();
          } else {
            this.$root.$data.BookingID = this.bookingID;
            this.$router.push({ name: "TransError" });
          }
        },
        (error) => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        },
        (failure) => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        }
      );
    },
    getStatusData() {
      const _data_ = {};
      TransJS.getTransStatus(_data_, this.isTourOperatorPayment).then(
        (response) => {
          // console.log(response);
          if (response.data.isSuccess) {
            document.getElementById("messageType").value =
              response.data.result.messageType; //1
            document.getElementById("merchantId").value =
              response.data.result.merchantId; //2
            document.getElementById("serviceId").value =
              response.data.result.serviceId; //3
            document.getElementById("orderId").value =
              response.data.result.orderId; //4
            document.getElementById("customerId").value =
              response.data.result.bookingId; //5
            document.getElementById("transactionAmount").value =
              response.data.result.transactionAmount; //6
            document.getElementById("currencyCode").value =
              response.data.result.currencyCode; //7
            document.getElementById("requestDateTime").value =
              response.data.result.requestDateTime; //8
            document.getElementById("successUrl").value =
              response.data.result.successUrl; //9
            document.getElementById("failUrl").value =
              response.data.result.failUrl; //10
            document.getElementById("additionalField1").value =
              response.data.result.additionalField1; //11
            document.getElementById("additionalField2").value =
              response.data.result.additionalField2; //12
            document.getElementById("additionalField3").value =
              response.data.result.additionalField3; //13
            document.getElementById("additionalField4").value =
              response.data.result.additionalField4; //14
            document.getElementById("additionalField5").value =
              response.data.result.additionalField5; //15
            document.getElementById("checksum").value =
              response.data.result.checksum; //16
            document.getElementById("frmData").action =
              response.data.result.requestURL; //17
            document.getElementById("frmPayment").submit();
          } else {
            alert(response.data.msg);
          }
        },
        (error) => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        },
        (failure) => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        }
      );
    },
    getStatusDataPost(message) {
      const params = message;
      TransJS.getTransRequestAPI(params).then(
        (response) => {
          // console.log(response);
        },
        (error) => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        },
        (failure) => {
          this.$root.$data.BookingID = this.bookingID;
          this.$router.push({ name: "TransError" });
        }
      );
    },
  },
  mounted() {
    if (this.$root.$data.BookingID != null) {
      let me = this;
      // this.PayBooking = this.$root.$data.PayBooking;
      this.isTourOperatorPayment = this.$root.$data.isTourOperatorPayment != null ? true : false;
      this.bookingID = this.$root.$data.BookingID;
      window.setTimeout(function () {
        me.getdata();
      }, 3000);
    } else if (this.isTourOperatorPayment == true) {
      this.$router.push({ name: "PaymentPortal" });
    }
    else {
      this.$router.push({ name: "TicketBooking" });
    }
  },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/TransRequest.vue